export default __webpack_public_path__ + "0a3ab01d9675874aba166047dfe9c0e5.otf";